import React, { FunctionComponent, useState } from 'react'

import { TKeyBuilder } from '../../../../infrastructure/internationalisation'
import { FormConfig } from '../../../../state/configuration'
import { SaveModal } from './SaveModal'
import { SuccessModal } from './SuccessModal'

export interface ProposalSaveModalProps {
  tKey: TKeyBuilder
  form: FormConfig
  onClose: () => void
}

export const ProposalSaveModal: FunctionComponent<ProposalSaveModalProps> = ({
  tKey,
  form,
  onClose,
}) => {
  const [saved, setSaved] = useState(false)

  return saved ? (
    <SuccessModal tKey={tKey} onClose={onClose} />
  ) : (
    <SaveModal tKey={tKey} form={form} onSave={() => setSaved(true)} />
  )
}
